import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { PurchaseorderService } from '../../../services/purchaseorder.service';
import { gridPageRequest } from '../../../model/common/common.model';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import _ from 'lodash';
import { SalesService } from '../../../services/sales.service';
import { InventoryService } from '../../../services/inventory.service';
import { AdministratorService } from '../../../services/administrator.service';
import { Warehouse } from '../../../model/administration.model';
import { ProjectBomLookupComponent } from '../../Lookup/projectbom-lookup/projectbom-lookup.component';
import { Table } from 'primeng/table';
import { setCurrentTimeOnDates } from '../../../services/utils/date-utils';

@Component({
  selector: 'app-create-store-consumptions',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './create-store-consumptions.component.html',
  styleUrl: './create-store-consumptions.component.scss'
})
export class CreateStoreConsumptionsComponent implements OnInit {
  @ViewChild('dt1') dt1: Table | undefined;
  loader: boolean = false;
  isEditMode: boolean = false;
  storeConsumptionId: number | null = null;
  selectedProduct: any[] = [];
  storeconsumptionData: any[] = [];
  deleteProductIds: any[] = [];
  ref: DynamicDialogRef | undefined;
  nonInventryProductList: any[] = [];
  visible: boolean = false;
  isEditModesc: boolean = false;
  warehouseDropdown: any[] = [];
  filtewarehouse: Warehouse[] = [];
  warehouseId: any;
  quantityAvail: any;
  submitted: boolean = false;
  unitLabel: string = '';


  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 100,
    id: 0
  };

  constructor(
    private purchaseorderService: PurchaseorderService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dialogService: DialogService,
    private router: Router,
    private route: ActivatedRoute,
    private salesService: SalesService,
    private inventoryService: InventoryService,
    private administratorService: AdministratorService
  ) { }

  storeConsumptionForm = new FormGroup({
    storeConsumptionId: new FormControl(0),
    ProjectManufacturingBatchID: new FormControl(0),
    empName: new FormControl('', Validators.required),
    fromDate: new FormControl(null, Validators.required),
    scCode: new FormControl('', Validators.required),
    endDate: new FormControl(null, Validators.required),
    manualEntry: new FormControl(false),
    totDays: new FormControl({ value: null, disabled: false }, Validators.required),
    laborRate: new FormControl(null),
    totLaborCost: new FormControl({ value: null, disabled: false }),
    IsActive: new FormControl(true),
    createdDate: new FormControl(),
    createdBy: new FormControl(),
    updatedBy: new FormControl(),
    updatedDate: new FormControl(),
    projectBoMName: new FormControl(''),
    projectBoMCode: new FormControl(''),
    warehouse: new FormControl('', Validators.required),
    warehouseId: new FormControl(),
    warehouseCode: new FormControl('', Validators.required),
  });

  // Line item form
  storeConsumptionLineitemForm = new FormGroup({
    storeConsumptionlineItemId: new FormControl(0),
    storeConsumptionId: new FormControl(0),
    productCode: new FormControl('', Validators.required),
    description: new FormControl(),
    serialNumber: new FormControl('', Validators.required),
    consumedQty: new FormControl(),
    openingInventory: new FormControl(),
    closingInventory: new FormControl(),
    totCost: new FormControl(),
    consumedInOperation: new FormControl(),
    rate: new FormControl(),
    manualEntry2: new FormControl(true),
    IsActive: new FormControl(true),
    createdDate: new FormControl(),
    createdBy: new FormControl(),
    updatedBy: new FormControl(),
    updatedDate: new FormControl(),
    date: new FormControl(),
    quantityAvail: new FormControl()
  });


  ngOnInit(): void {
    document.title = 'Create Store Consumption';
    this.storeConsumptionForm.controls['createdBy'].setValue(localStorage.getItem('username'));
    this.getWarehouse();
    this.route.queryParams.subscribe(params => {
      const idParam = params['id'];
      if (idParam) {
        this.isEditMode = true;
        this.storeConsumptionId = Number(idParam);
        this.loadHeader(this.storeConsumptionId);
        this.loadLineItems(this.storeConsumptionId);
      } else {
        this.isEditMode = false;
        this.autogenerateHeaderCode();
      }
    });

    this.storeConsumptionForm.controls['fromDate'].valueChanges.subscribe(() => this.onDateChange());
    this.storeConsumptionForm.controls['endDate'].valueChanges.subscribe(() => this.onDateChange());
    this.storeConsumptionForm.controls['laborRate'].valueChanges.subscribe(() => this.calculateTotLaborCost());

    this.storeConsumptionLineitemForm.controls['rate'].valueChanges.subscribe(() => {
      this.calculateTotalCost();
    });

    this.storeConsumptionLineitemForm.controls['consumedQty'].valueChanges.subscribe(() => {
      this.calculateTotalCost();
    });

    this.storeConsumptionLineitemForm.controls['openingInventory'].valueChanges.subscribe(() => {
      this.calculateTotalCost();
    });

    this.inventoryService.getUnitByAppKey('unitNameLabel').subscribe((res: any) => {
      this.unitLabel = res?.data || 'Unit';
    });
  }

  get formControls() {
    return this.storeConsumptionForm.controls;
  }

  get formControlslineitem() {
    return this.storeConsumptionLineitemForm.controls;
  }

  onDateChange() {
    const fromDate = this.storeConsumptionForm.controls['fromDate'].value as any;
    const endDate = this.storeConsumptionForm.controls['endDate'].value as any;
    if (fromDate && endDate) {
      const start = new Date(fromDate);
      const end = new Date(endDate);
      if (start > end) {
        this.messageService.add({ severity: 'error', summary: 'Invalid Date Range', detail: 'End Date cannot be earlier than Start Date.' });
        this.storeConsumptionForm.controls['totDays'].setValue(null as any);
        this.storeConsumptionForm.controls['totLaborCost'].setValue(null as any);
        return;
      }
      const diffTime = Math.abs(end.getTime() - start.getTime());
      const totDays = Math.ceil(diffTime / (1000 * 3600 * 24));
      this.storeConsumptionForm.controls['totDays'].setValue(totDays as any);
      this.calculateTotLaborCost();
    }
  }

  calculateTotLaborCost() {
    const totDays = this.storeConsumptionForm.controls['totDays'].value as any;
    const laborRate = this.storeConsumptionForm.controls['laborRate'].value as any;
    if (totDays && laborRate) {
      const totLaborCost = Number(totDays) * Number(laborRate);
      this.storeConsumptionForm.controls['totLaborCost'].setValue(totLaborCost as any);
    }
  }

  autogenerateHeaderCode() {
    this.purchaseorderService.autogenerateSCNumber().subscribe({
      next: (data: any) => {
        // const order = `SC${data}`;
        // this.storeConsumptionForm.controls['scCode'].setValue(_.toString(order));
        this.storeConsumptionForm.controls['scCode'].setValue(data.fullNumber);
      },
      error: () => { }
    });
  }

  manualEntry() {
    const manual = this.storeConsumptionForm.controls['manualEntry'].value;
    if (manual === true) {
      this.storeConsumptionForm.controls['scCode'].setValue('' as any);
    } else {
      this.autogenerateHeaderCode();
    }
  }

  checkSCNumber() {
    const sc = this.storeConsumptionForm.controls['scCode'].value as any;
    if (!sc || this.isEditMode) { return; }
    this.purchaseorderService.checkSCNumber(sc).subscribe({
      next: (data: any) => {
        if (data?.success !== true) {
          this.storeConsumptionForm.controls['manualEntry'].setValue(true as any);
        }
      }
    });
  }

  loadHeader(id: number) {
    this.loader = true;
    document.title = 'Update Store Consumption';
    this.purchaseorderService.getStoreConsumptionById(id).subscribe({
      next: (data: any) => {
        const fromDate = data?.fromDate ? new Date(data.fromDate) : null;
        const endDate = data?.endDate ? new Date(data.endDate) : null;
        this.storeConsumptionForm.patchValue({
          storeConsumptionId: data.storeConsumptionId,
          ProjectManufacturingBatchID: data.projectManufacturingBatchID,
          empName: data.empName,
          fromDate: fromDate as any,
          endDate: endDate as any,
          scCode: data.scCode,
          totDays: data.totDays,
          laborRate: data.laborRate,
          totLaborCost: data.totLaborCost,
          projectBoMCode: data.projectBoMCode,
          projectBoMName: data.projectBoMName,
          warehouseId: data.warehouseId,
          warehouseCode: data.warehouseCode,
          warehouse: data.warehouseCode,
        } as any);
        this.loader = false;
        this.warehouseId = data.warehouseId;
      },
      error: () => { this.loader = false; }
    });
  }

  loadLineItems(id: number) {
    this.purchaseorderService.getStoreConsumptionlineitemByScId(id).subscribe({
      next: (data: any[]) => { this.storeconsumptionData = data || []; },
      error: () => { }
    });
  }

  // Warehouse
  getWarehouse() {
    this.administratorService.getAllWarehouse(this.pageRequest).subscribe({
      next: (data: any) => { this.warehouseDropdown = data?.warehouses || []; },
      error: () => { }
    });
  }

  filteWarehouse(event: any) {
    const query = (event?.query || '').toLowerCase();
    this.filtewarehouse = (this.warehouseDropdown as any[]).filter((w: any) => (w.warehouseCode || '').toLowerCase().startsWith(query));
  }

  setWarehouse(data: any) {
    if (data?.value) {
      this.storeConsumptionForm.controls['warehouseId'].setValue(data.value.warehouseId as any);
      this.storeConsumptionForm.controls['warehouseCode'].setValue(_.toString(data.value.warehouseName) as any);
      this.warehouseId = data.value.warehouseId;
    }
  }

  // Project BOM lookup
  getProduct() {
    this.ref = this.dialogService.open(ProjectBomLookupComponent, {
      header: 'Project List',
      width: '70%'
    });
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.storeConsumptionForm.patchValue({
          projectBoMName: data.projectBoMName,
          projectBoMCode: data.projectBoMCode
        } as any);
      }
    });
  }


  manualEntry2() {
    const manual = this.storeConsumptionLineitemForm.controls['manualEntry2'].value as any;
    if (manual === true) {
      this.storeConsumptionLineitemForm.controls['serialNumber'].setValue('' as any);
    } else {
      this.getOrderNumber();
    }
  }

  checkMONumber() {
    const mo = this.storeConsumptionLineitemForm.controls['serialNumber'].value as any;
    if (!mo || this.isEditModesc) { return; }
    this.purchaseorderService.checkMONumber(mo).subscribe({
      next: (data: any) => {
        if (data?.success !== true) {
          this.storeConsumptionLineitemForm.controls['manualEntry2'].setValue(true as any);
        }
      }
    });
  }

  getOrderNumber() {
    this.purchaseorderService.autogenerateSCLNumber().subscribe({
      next: (data: any) => {
        //console.log(data);

        const alphanumericCode = 'SC';
        const order = alphanumericCode + data;
        this.storeConsumptionLineitemForm.controls['serialNumber'].setValue(_.toString(order) as any);
        // this.storeConsumptionLineitemForm.patchValue({
        //   serialNumber: data.serialNumber
        // });
      },
      error: () => { }
    });
  }

  showDialog() {
    this.visible = true;
    this.isEditModesc = false;
    this.resetForm();
    this.getOrderNumber();
  }

  addNewItem() {
    this.selectedProduct = [];
    this.showDialog();
  }

  resetForm() {
    this.storeConsumptionLineitemForm.reset();
    this.isEditModesc = false;
  }

  cancels() {
    this.visible = false;
    this.resetForm();
    this.selectedProduct = [];
  }

  editStoreConsumptionLineitem(data: any) {
    this.isEditModesc = true;
    const SPDate = data?.date ? new Date(data.date) : null;
    this.storeConsumptionLineitemForm.patchValue({
      storeConsumptionId: data.storeConsumptionId,
      storeConsumptionlineItemId: data.storeConsumptionlineItemId,
      serialNumber: data.serialNumber,
      rate: data.rate,
      productCode: data.productCode,
      consumedQty: data.consumedQty,
      openingInventory: data.openingInventory,
      closingInventory: data.closingInventory,
      consumedInOperation: data.consumedInOperation,
      totCost: data.totCost,
      description: data.description,
      date: SPDate
    } as any);
    const code = (data.productCode || '').split(' ')[0];
    if (code) { this.getInventoryStatus(code); }
    this.visible = true;
  }

  autoSearchNonInventryProducts(event: any) {
    this.salesService.autoSearchProduct(event.query).subscribe({
      next: (data: any[]) => { this.nonInventryProductList = data || []; },
      error: () => { }
    });
  }

  setProducts(data: any) {
    const productCode = data?.value?.productCode;
    const productName = data?.value?.productName;
    const rate = data?.value?.salesPrice;
    this.storeConsumptionLineitemForm.controls['rate'].setValue(rate as any);
    const display = `${productCode} - ${productName}`;
    this.storeConsumptionLineitemForm.controls['productCode'].setValue(display as any);
    if (productCode) { this.getInventoryStatus(productCode); }
  }

  getInventoryStatus(productCode: string) {
    this.inventoryService.getInventoryStatus(productCode).subscribe({
      next: (data: any) => {
        if (Array.isArray(data)) {
          const item = data.find((x: any) => x.warehouseId === this.warehouseId);
          if (item) {
            this.storeConsumptionLineitemForm.controls['quantityAvail'].setValue(item.quantityAvailable as any);
          }
        }
      },
      error: () => { }
    });
  }

  calculateTotalCost() {
    const rate = Number(this.storeConsumptionLineitemForm.controls['rate'].value);
    const qty = Number(this.storeConsumptionLineitemForm.controls['consumedQty'].value);
    const openingInventory = Number(this.storeConsumptionLineitemForm.controls['openingInventory'].value);

    const totalCost = rate * qty;
    this.storeConsumptionLineitemForm.controls['totCost'].setValue(isNaN(totalCost) ? 0 : totalCost);

    const closingInventory = openingInventory - qty;
    this.storeConsumptionLineitemForm.controls['closingInventory'].setValue(isNaN(closingInventory) ? 0 : closingInventory);
  }

  CreateStoreConsumptionLineitem(data: any) {
    const requiredFields = ['serialNumber', 'productCode', 'consumedQty', 'totCost', 'rate', 'date', 'openingInventory'];
    for (const field of requiredFields) {
      const v = data[field];
      if (v === null || v === undefined || v === '') {
        this.messageService.add({ severity: 'warn', summary: 'Validation Error', detail: `${field} is required.` });
        return;
      }
    }

    if (this.isEditModesc) {
      const index = this.storeconsumptionData.findIndex(item => item.serialNumber === data.serialNumber);
      if (index !== -1) { this.storeconsumptionData[index] = data; }
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Store Consumption Line Item Updated Successfully.' });
    } else {
      this.storeconsumptionData.push(data);
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Store Consumption Line Item Created Successfully.' });
      this.moveToLastPage();
    }

    this.visible = false;
    this.selectedProduct = [];
  }

  get totalConsumedQty(): number {
    return this.storeconsumptionData?.reduce((sum, item) => sum + (item.consumedQty || 0), 0) || 0;
  }

  get totalCost(): number {
    return this.storeconsumptionData?.reduce((sum, item) => sum + (item.totCost || 0), 0) || 0;
  }

  private moveToLastPage(): void {
    if (!this.dt1) { return; }
    const rows = this.dt1.rows ?? 10;
    const total = this.storeconsumptionData.length;
    const lastFirstIndex = Math.floor((total - 1) / rows) * rows;
    this.dt1.first = lastFirstIndex;
  }

  editItem() {
    if (this.selectedProduct && this.selectedProduct.length === 1) {
      this.editStoreConsumptionLineitem(this.selectedProduct[0]);
    }
  }

  editItemFromRow(item: any) {
    if (item) {
      this.editStoreConsumptionLineitem(item);
    }
  }

  validateForm() {
    let isValid = true;
    if (this.storeConsumptionForm.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required fields' });
      isValid = false;
    }

    return isValid;
  }


  deleteSClineItems() {
    if (!this.selectedProduct || this.selectedProduct.length === 0) { return; }
    this.confirmationService.confirm({
      header: 'Are you sure?',
      message: 'Please confirm to proceed.',
      accept: () => {
        const ids = this.selectedProduct.map(p => p.storeConsumptionlineItemId).filter((x: any) => x);
        if (this.isEditMode && ids.length) { this.deleteProductIds.push(...ids); }
        for (const sel of this.selectedProduct) {
          const idx = this.storeconsumptionData.findIndex(item => item.serialNumber === sel.serialNumber);
          if (idx !== -1) { this.storeconsumptionData.splice(idx, 1); }
        }
        this.selectedProduct = [];
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Store Consumption Line Item Deleted successfully.' });
        if (this.dt1) {
          const rows = this.dt1.rows ?? 10;
          const total = this.storeconsumptionData.length;
          const lastFirstIndex = total > 0 ? Math.floor((total - 1) / rows) * rows : 0;
          const currentFirst = this.dt1.first ?? 0;
          if (currentFirst > lastFirstIndex) {
            this.dt1.first = lastFirstIndex;
          }
        }
      }
    });
  }

  saveOrUpdate() {
    this.submitted = true;

    const isValid = this.validateForm();
    if (!isValid) return;
    const data = { ...this.storeConsumptionForm.getRawValue() } as any;
    const currentTime = new Date();

    if (data.fromDate) {
      (data.fromDate as Date).setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
    }

    if (data.endDate) {
      (data.endDate as Date).setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
    }

    if (this.isEditMode) {
      data.UpdatedBy = localStorage.getItem('username');

      this.purchaseorderService.updateStoreCnsumption([data]).subscribe({
        next: () => {
          this.processLineItems(data.storeConsumptionId);
          if (this.deleteProductIds?.length) {
            this.purchaseorderService.deleteStoreConsumptionLineItem(this.deleteProductIds).subscribe();
          }

          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Store Consumption Updated Successfully.'
          });

          setTimeout(() => this.router.navigate(['/home/storeconsumption']), 1000);
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to update store consumption.'
          });
        }
      });

    } else {
      const isValid = this.validateForm();
      if (!isValid) {
        return;
      }
      this.purchaseorderService.CreateStoreConsumption(data).subscribe({
        next: (response: any) => {
          const newId = response?.id || response;

          this.processLineItems(newId);

          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Store Consumption added successfully'
          });

          setTimeout(() => this.router.navigate(['/home/storeconsumption']), 1000);
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to save store consumption.'
          });
        }
      });
    }
  }

  private processLineItems(storeConsumptionId: number) {
    const items = (this.storeconsumptionData || []).map(item => ({
      ...item,
      storeConsumptionId: item.storeConsumptionId || storeConsumptionId,
      storeConsumptionlineItemId: item.storeConsumptionlineItemId ?? 0,
      IsActive: item.IsActive ?? true
    }));

    setCurrentTimeOnDates(items);

    items.forEach(item => {
      const hasId = item.storeConsumptionId && item.storeConsumptionlineItemId;

      if (hasId && item.storeConsumptionlineItemId !== 0) {
        this.updateStoreConsumptionLineItem(item).catch(err => {
          console.error('Failed to update line item:', err);
        });
      } else {
        this.purchaseorderService.CreateStoreConsumptionLineItem([item]).subscribe({
          error: err => {
            console.error('Failed to create line item:', err);
          }
        });
      }
    });
  }


  updateStoreConsumptionLineItem(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      if (data) {
        data.UpdatedBy = localStorage.getItem('username');
        this.loader = true;
        const currentTime = new Date();

        if (data.date) {
          (data.date as Date).setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
        }
        const payload = [data];

        this.purchaseorderService.updateStoreConsumptionLineItem(payload).subscribe({
          next: (response) => {
            this.loader = false;
            resolve(response);
          },
          error: (error) => {
            this.loader = false;
            console.error('Update failed:', error);
            reject(error);
          }
        });
      } else {
        reject('No data to update');
      }
    });
  }

  cancel() {
    this.router.navigate(['/home/storeconsumption']);
  }
}
